import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { Title, DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { NavController, Platform } from "@ionic/angular";
import { DefaultPageComponent } from "../../shared/page/default-page.component";
import { AnalycticsNativeService } from "../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../shared/service/comunicator-native/back-native/back-native";
import { ReturnNativeService } from "../../shared/service/comunicator-native/return-native/return-native";
import { JourneyService } from "../../shared/service/journey/journey.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { LikertFactoryService } from "../../shared/service/likert/likert-factory-service";
import { DataOrigin } from "../../shared/model/DataOrigin";
import { setVoiceOverFocus } from "@ids/tools";
import { OptionLikert } from "../../shared/service/likert/model/likert.model";
import { ReturnHomeService } from "../../../app/shared/service/comunicator-native/return-home/return-home";
import { AnalyticsGA4PageService } from "../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { ParamDefaultGA4 } from "../../shared/service/comunicator-native/track-ga4-native/itrack-ga4-native";
import { LocalStorageService } from "../../shared/service/storage/storage.service";
import { LikertOptionKey } from '@ids/tools';
import { OpportunitiesForYouSuccessScreenModel } from "src/app/shared/model/opportunities-for-you-success.model";
import { Subscription } from "rxjs";
import { NavigationExtras, Router } from "@angular/router";
import { OpportunitiesForYouTestAbService } from "../../shared/service/opportunities-for-you-test-ab/opportunities-for-you-test-ab.service";
import { AbWebview } from "../../../app/shared/enums/ab-webview.enum";

interface AnalyticsPage {
  pageName: string;
  action: string;
  back: string;
  dataAnalysisStatus: string;
  dataAnalysisStatusLabel: string;
  dataAnalysisStatusEvent: string;
}

interface AnalyticsGA4Page {
  paramDefautl: ParamDefaultGA4;
  paramComplementary?: Record<string, string>;
}

declare const GrowthInterface;

@Component({
  selector: "app-data-analysis",
  templateUrl: "./data-analysis.component.html",
  styleUrls: ["./data-analysis.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DataAnalysisComponent
  extends DefaultPageComponent
  implements OnInit
{
  headerId = "data-analysis";
  titlePage = "";
  focusId: string;
  approved = false;
  titleContent: string;
  description: SafeHtml;
  analyticsPage: AnalyticsPage;
  analyticsPageGA4: AnalyticsGA4Page;
  icon: string;
  likert: boolean;
  nomeJornada: string;
  navegJornada: string;
  textareaLabel: string;
  backNative = false;
  dataOrigin = DataOrigin.Mobile;
  likertSuccess = false;
  likertError = false;
  maxLength = 280;
  voicePageLabel = "";
  @ViewChild("inputText") inputText: any;
  public varianteOpportunitiesForYou: OpportunitiesForYouSuccessScreenModel
  public opportunitiesForYouSubscription: Subscription;
  termsData: any = {}
  form: FormGroup;
  likertOptions = ['veryBad', 'bad', 'okay', 'good', 'veryGood'];
  feedbackAlert = false;
  likertSelectedOptions: string;
  characters: number = 280;
  public nativeString: string

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private title: Title,
    // private formBuilder: FormBuilder,
    public returnNativeService: ReturnNativeService,
    private analycticsNativeService: AnalycticsNativeService,
    private sanitizer: DomSanitizer,
    private route: Router,
    private likertFactoryService: LikertFactoryService,
    private returnHomeService: ReturnHomeService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    public opportunitiesService: OpportunitiesForYouTestAbService,
    public platform: Platform,
    private storage: LocalStorageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.headerFocusPage();
    this.loadData();
    // this.analyticsEventClique();
    this.initOpportunitiesForYouTestAb();

    this.form = new FormGroup({
      likertOptions: new FormControl<LikertOptionKey | ''>('', [Validators.required]),
      comment: new FormControl(''),
    });
  }

  ngOnDestroy(): void {
    if (this.opportunitiesForYouSubscription) {
      this.opportunitiesForYouSubscription.unsubscribe();
    }
  }

  /**
   * Initializes testAB service and retrieves the variation data.
   */
  public initOpportunitiesForYouTestAb(): void {
    this.opportunitiesForYouSubscription = this.opportunitiesService.getData()
      .subscribe(data => this.varianteOpportunitiesForYou = data);
  }

  ngOnInit(): void {
    // TODO document why this method 'ngOnInit' is empty
  }

  isNegativeAnswer() {
    const answer = this.form.get('likertOptions')?.value as LikertOptionKey;

    return answer === 'bad' || answer === 'veryBad';
  }

  isPositiveAnswer() {
    const answer = this.form.get('likertOptions')?.value as LikertOptionKey;

    return ['okay', 'good', 'veryGood'].includes(answer);
  }

  countCharacter(event: any) {
    this.characters = 280 - event?.length;
  }

  ionViewWillEnter() {
    this.headerFocusPage();
    this.verifyCameFromLogin();
  }

  headerFocusPage() {
    const time = document.querySelector(".plt-ios") ? 10 : 200;
    this.headerFocusBrowser(time);
  }

  verifyCameFromLogin() {
    const cameFromLogin: string = localStorage.getItem("cameFromLogin");

    if (cameFromLogin) {
      localStorage.removeItem("cameFromLogin");
    }
  }

  getPageId(): string {
    return this.headerId;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  backPage() {
    // Deixar o comentário aqui pois pode ser que essa regra volte a ser usada... 
    // if (this.backNative) {
    //   this.backJourney();
    // } else {
    //   this.returnHomeService.returnCommunicator();
    // }
    this.sendTrackGA4Click();
    this.returnHomeService.returnCommunicator();
  }

  clickDefinirPerfil() {
    if (this.analyticsPage) {
      this.analyticsEventCliquePerfilInvestidor();
    }
    this.endJourney();
  }

  loadData() {
    if (this.journeyService.journey === 'basic-v2' 
      || this.journeyService.journey === 'basic-marital-v2'
      || this.journeyService.journey === 'basic-personal-v2'
      || this.journeyService.journey === 'basic-address-v2'
      || this.journeyService.journey === 'basic-professional-v2'
      || this.journeyService.journey === 'basic-income-v2'
      || this.journeyService.journey === 'basic-profile-v2') {
      this.termsData = this.storage.get('data-analisys-basic');
    }else{
      this.termsData = this.storage.get('data-analisys');
    }
    if (this.termsData) {
      this.titleContent = this.termsData?.titleContent;
      this.description = this.sanitizer.bypassSecurityTrustHtml(
        this.termsData?.description
      );
      this.analyticsPage = this.termsData?.analyticsPage;
      this.analyticsPageGA4 = this.termsData?.analyticsPageGA4;
      this.icon = this.termsData?.icon;
      this.likert = this.termsData?.likert;
      this.nomeJornada = this.termsData?.nomeJornada;
      this.navegJornada = this.termsData?.navegJornada;
      this.backNative = this.termsData?.backNative;
    }

    if (this.analyticsPage) {
      this.analyticsData();
    }

    if (this.analyticsPageGA4) {
      this.sendTrackGA4LoadPage();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.pageName;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.paramDefautl.event_name,
      custom_path: this.analyticsPageGA4.paramDefautl.custom_path,
      implementation_team:
        this.analyticsPageGA4.paramDefautl.implementation_team,
    };

    if (this.varianteOpportunitiesForYou && this.varianteOpportunitiesForYou.isActive === true) {
      const paramComplementary = {
        teste_id: this.varianteOpportunitiesForYou.test_id, 
        test_variant: this.varianteOpportunitiesForYou.test_variant,
      };

      this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  private sendTrackGA4Click(detail: string = 'fechar'): void {
    const paramDefautl = {
      event_name: 'click',
      custom_path: this.analyticsPageGA4?.paramDefautl?.custom_path,
      implementation_team:
        this.analyticsPageGA4?.paramDefautl?.implementation_team,
      detail: detail,
    };

    if (this.varianteOpportunitiesForYou && this.varianteOpportunitiesForYou.isActive === true) {
      const paramComplementary = {
        teste_id: this.varianteOpportunitiesForYou.test_id, 
        test_variant: this.varianteOpportunitiesForYou.test_variant,
      };

      this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
    }

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  analyticsEventClique() {
    const it_eventcategory = this.analyticsPage?.dataAnalysisStatusEvent
      ? this.analyticsPage?.dataAnalysisStatusEvent
      : "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage?.dataAnalysisStatusLabel
        ? this.analyticsPage.dataAnalysisStatusLabel
        : this.analyticsPage.back,
      it_pagename: this.analyticsPage.pageName,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  analyticsEventCliquePerfilInvestidor() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: "BTN:DefinirPerfilInvestidor",
      it_pagename: this.analyticsPage.pageName,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  analyticsEventCliqueHome() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: "BTN:PaginaInicial",
      it_pagename: this.analyticsPage.pageName,
    };
    
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  private analyticsEventCliqueTesteAb(): void  {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: "BTN:PaginaInicial",
      it_pagename: this.analyticsPage.pageName,
      teste_id: this.varianteOpportunitiesForYou.test_id,
      test_variant: this.varianteOpportunitiesForYou.test_variant,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  endJourneyNative() {
    if (this.analyticsPage) {
      this.analyticsEventCliqueHome();
    }

    this.returnHomeService.returnCommunicator();
  }

  sendResponse($event: any) {
    $event.preventDefault();

    const answer = this.form.get('likertOptions')?.value as LikertOptionKey;
    const nota = this.getNota(answer);    
    const likertForm = {
      nota: nota,
      comentario: this.form.controls.comment.value.trim(),
      perguntas_adicionais: "",
      nome_jornada: this.nomeJornada,
      naveg_jornada: this.navegJornada,
      dispositivo: navigator.userAgent + "|W",
    };

    this.likertFactoryService
      .getService(this.dataOrigin)
      .postLikert(likertForm)
      .then((resp: any) => {
        if (resp.data) {
          this.likert = false;
          this.likertSuccess = true;
          this.setTitleFeedbackLikert();
        } else {
          this.setStatusLikertError();
        }
      })
      .catch(() => {
        this.setStatusLikertError();
      });
  }
   
  private getNota(value: string | null): number {
    if(value) {
      switch (value) {
        case 'veryGood':
          return 5;
        case 'good':
          return 4;
        case 'okay':
          return 3;
        case 'bad':
          return 2;
        case 'veryBad':
          return 1;
      }
    }    
    return 0;
  }

  setTitleFeedbackLikert() {
    setTimeout(() => {
      const isIos = document.querySelector(".plt-ios");
      const title = document.querySelector(
        "#feedback-likert-title"
      ) as HTMLElement;
      if (title) {
        if (isIos) {
          document.body.setAttribute("aria-hidden", "true");
          setTimeout(() => {
            document.body.removeAttribute("aria-hidden");
            setVoiceOverFocus(title);
          }, 200);
        } else {
          setVoiceOverFocus(title);
        }
      }
    }, 10);
  }

  setStatusLikertError() {
    this.likert = false;
    this.likertError = true;
    this.setTitleFeedbackLikert();
  }

  submitInput(e: any) {
    if (e.which === 13) {
      this.inputText.nativeElement.blur();
      setTimeout(() => this.inputText.nativeElement.focus(), 200);
    }
  }

  submitForm() {
    return false;
  }

  keyPressed() {
    const rest =
      this.maxLength - this.form.controls.comment.value.length;

    setTimeout(() => {
      if (this.form.controls.comment.value.length > this.maxLength) {
        this.form.controls.comment.setValue(
          this.form.controls.comment.value.slice(0, this.maxLength)
        );
      }
    }, 10);

    if (rest >= -1 && rest < 21) {
      setTimeout(() => {
        this.voicePageLabel =
          rest === -1
            ? `0 caracteres restantes`
            : `${rest} caracteres restantes`;

        if (rest === 20 || rest <= 0) {
          setTimeout(() => (this.voicePageLabel = ""), 1000);
        }
      }, 1000);
    }
  }

  responseChangeLabel(e: OptionLikert) {
    if (e.order === 1 || e.order === 2 || e.order === 3) {
      this.textareaLabel = "O que deu errado? (opcional)";
    } else {
      this.textareaLabel = "O que você gostou? (opcional)";
    }

    this.setAriaHiddenLabel();
  }

  setAriaHiddenLabel() {
    setTimeout(() => {
      const label = document.querySelector('[for="ids-input-0"]');

      if (label) {
        label.setAttribute("aria-hidden", "true");
      }
    }, 50);
  } 

  /**
   * Teste AB com Remote Config
   * verifyIfTestAbActive verifica se o teste AB está ativo
   * analyticsEventTestABShowFalse é chamado quando a show do teste AB é false
   * handleClickTestAb é chamado quando o usuário clica no botão do teste AB
   */

  /**
   * @returns boolean
   * this.varianteOpportunitiesForYou é o retorno do teste AB
   * jsonObject é o retorno do teste AB convertido em JSON
   * condicional para verificar se teste está ativo e show true
   * caso show false chama analyticsEventTestABShowFalse para taguear no analytics
   */
  public verifyIfTestAbActive(): boolean {

    // console.log('LOG REMOTE_CONFIG:', this.nativeString);    

    if (this.varianteOpportunitiesForYou) {

      const jsonObject  = this.varianteOpportunitiesForYou;

      if (this.checkSistemaOperacional(jsonObject) ) {

        if (jsonObject.isActive === false) {
          return false;
        } else {
          return true;
        }
      }
    }
    return false;
  }


  /**
   * verifica se o sistema operacional é ios ou android
   * @param jsonData JSON da fundação
   * @returns string (ios || android)
   */
  //escreva test unitario para função abaixo

  public checkSistemaOperacional(jsonData): boolean  {
    let hasSistemaOperacional;

    if ('sistemaOperacional' in jsonData && jsonData.sistemaOperacional.length > 0) {

        hasSistemaOperacional = jsonData.sistemaOperacional;

        if (hasSistemaOperacional.includes('ios') && this.platform.is('ios') ) {
          return true;
        } else  if (hasSistemaOperacional.includes('android')) {
          return true;
        } else {
          return false;
        }
    }
    return false;
  }

  /**
   * @returns void
   * jsonObject é o retorno do teste AB convertido em JSON
   * navigationExtras é o objeto que será passado como parâmetro para a próxima tela
   * queryParams é o objeto que será passado como parâmetro para a próxima tela
   * dataParams é o objeto que será passado como parâmetro para a próxima tela
   * this.router.navigateForward(['new-products', 'new-products'], navigationExtras) navega para a próxima tela
   */
  public handleClickTestAb(): void {
    const jsonObject =  JSON.stringify(this.varianteOpportunitiesForYou);

    this.analyticsEventCliqueTesteAb();
    this.sendTrackGA4Click(this.varianteOpportunitiesForYou.rotuloBotao);

    let navigationExtras: NavigationExtras = {
      queryParams: {
          dataParams: jsonObject,
      }
    };

    this.router.navigateForward(['new-products', 'new-products'], navigationExtras);
  }
}
